import { render, staticRenderFns } from "./PiwikComponent.vue?vue&type=template&id=099fdfc2&scoped=true"
import script from "./PiwikComponent.vue?vue&type=script&lang=js"
export * from "./PiwikComponent.vue?vue&type=script&lang=js"
import style0 from "./PiwikComponent.vue?vue&type=style&index=0&id=099fdfc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099fdfc2",
  null
  
)

export default component.exports